import type { QueryResultDetails } from "@rocicorp/zero";
import type { ConnectorMembershipUsageType } from "../../shared/connectorUsagePolicies";
import {
  connectorMembershipQueries,
  usedConnectorsForSpace,
} from "../lib/connectorMembershipPreflight";
import { useQuery } from "@rocicorp/zero/react";

export function useSpaceUsedSuppliers<T extends { id: string }>(
  connectors: readonly T[],
  spaceId: string | undefined
) {
  const requests = spaceId ? connectorMembershipQueries(spaceId) : undefined;
  const [spaces = [], spacesResult] = useQuery(requests?.commit_step);
  const [gitRemote, gitResult] = useQuery(requests?.space_git_remote);
  const results = {
    commit_step: spacesResult,
    space_git_remote: gitResult,
  } satisfies Record<ConnectorMembershipUsageType, QueryResultDetails>;
  const usedConnectors = usedConnectorsForSpace(connectors, {
    commit_step: spaces,
    space_git_remote: gitRemote,
  });
  const usedConnectorsLoaded = Object.values(results).every(
    (result) => result.type === "complete"
  );
  return { usedConnectors, usedConnectorsLoaded };
}
